export default __webpack_public_path__ + "static/media/SummaryBackground3.00889f51.svg";